module.exports = __webpack_public_path__ + "media/bootstrap-icons/heart-fill-9733c4fb.svg";